export default __webpack_public_path__ + "static/media/arrow.07aa0fa4.svg";